import { hookstate } from '@hookstate/core';
import { createContext } from 'react';

export const globalIsAdminState = hookstate(false);

export const globalBlockedState = hookstate(false);

export const globalShowCguState = hookstate(false);

export const ToastContext = createContext();

export const HelpContext = createContext();
